<template>
    <div>
        <transition name="fade" mode="out-in">
            <areal
                :floors="floors"
                v-if="floors.length > 0 && !floorOpen"
            ></areal>
            <div v-else-if="floorOpen">
                <floor :floor="floorOpenData"></floor>
            </div>
            <div v-else>
                <loader :text="true" :fullscreen="true"></loader>
            </div>
        </transition>
    </div>
</template>

<script>
import Areal from "./components/Areal.vue";
import Floor from "./components/Floor.vue";

export default {
    components: {
        Areal,
        Floor,
    },
    data() {
        return {
            lots: [],
            floors: [],
            floorOpen: false,
            floorOpenData: null,
        };
    },
    provide() {
        return {
            toggleFloor: this.toggleFloor,
            closeFloorOpen: this.closeFloorOpen,
        };
    },
    methods: {
        toggleFloor(floor) {
            this.floorOpen = true;
            this.floorOpenData = floor;
        },
        closeFloorOpen() {
            this.floorOpen = false;
            this.floorOpenData = null;
        },

        async fetchLots() {
            try {
                const response = await this.$axios.get("/api/poschodia/zoznam");
                const responseData = response.data;
                // console.log(responseData);

                this.floors = responseData.data;
            } catch (error) {
                console.log(error);
            }
        },
    },
    mounted() {
        this.fetchLots();
    },
};
</script>

<style lang="scss">
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>
